import { CREATE_WHATSAPP_CUSTOMER, GET_WHATSAPP_CUSTOMER, WHATSAPP_CUSTOMER_REQUEST, WHATSAPP_CUSTOMER_REQUEST_FAILURE, WHATSAPP_CUSTOMER_REQUEST_SUCCESS } from "../types";

const initialState = {
  whatsappCustomers: [],
  customerDetail: {},
  loading: false,
  error: null,
};

const whatsappCustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHATSAPP_CUSTOMER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_WHATSAPP_CUSTOMER: {
      return {
        ...state,
        whatsappCustomers: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_WHATSAPP_CUSTOMER:
      console.log('<<action---', action.payload)
      return {
        ...state,
        whatsappCustomers: [action.payload, ...state.whatsappCustomers],
        loading: false,
        error: null
      };
    case WHATSAPP_CUSTOMER_REQUEST_SUCCESS: {
      return {
        ...state,
        customerDetail: [action.payload],
        loading: false,
        error: null
      }
    }
    case WHATSAPP_CUSTOMER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default whatsappCustomerReducer;